export class UpdateWorkspaceStorageAccessConfigurationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "WorkspaceAwsStorageAccessConfiguration",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceStorageAccessConfigurationInput.attributeTypeMap;
    }
    constructor() {
    }
}
